import config from '../config';
import api from './axios.service';
const axios = api;

const getCategories = async () => {
    try {
        let response = await axios.get(`/categories`);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

const getCategory = async (id) => {
    try {
        let response = await axios.get(`/categories/${id}`);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

const addCategory = async (payload) => {
    try {
        let response = await axios.post(`/categories`, payload);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

const updateCategory = async (id, payload) => {
    try {
        let response = await axios.patch(`/categories/${id}`, payload);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

const deleteCategory = async (id) => {
    try {
        let response = await axios.delete(`/categories/${id}`);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

export {
    getCategories,
    getCategory,
    addCategory,
    updateCategory,
    deleteCategory
};
